import { InjectionToken } from '@angular/core';

export interface EnvironmentConfig {
  production: boolean;
  useMocks: boolean;
  serviceUrlPrefix: string;
  loginUrl: string;
  logoutUrl: string;
  downloadDocumentUrl: string;
  maintenanceExitUrl: string;
  downloadZipUrl: string;
  userProfileUrl: string;
  cookieSetting: object;
  cookieNameInbox: string;
  accessManagement: string;
}

export const ENV_CONFIG = new InjectionToken<EnvironmentConfig>('EnvironmentConfig');
